<template>
  <div class="page-container">
    <div class="page-header clear-filter" filter-color="dark">
      <parallax
        class="page-header-image"
        style="background-image: url('img/cover.jpg')"
      ></parallax>

      <div class="page-header-container">
        <div class="content-center brand cover-info-box">
          <img
            class="platform-logo"
            src="img/main/logo.png"
            alt="Platform Logo"
          />
          <div class="page-header-title">{{ $t("menu.platform_name") }}</div>
          <div class="page-header-description">
            {{ transformYear($t("menu.banner_description")) }}
          </div>

          <div class="more-detail-button" @click="go_to_map">
            <i class="fas fa-angle-double-down"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="section" id="section-map">
      <div class="container">
        <b-row>
          <b-col md="8" lg="5">
            <MapCSS :data="blossom_dates"></MapCSS>
          </b-col>
          <b-col md="4" lg="7">
            <StationSummary
              class="map-summary-area"
              :data="blossom_dates"
            ></StationSummary>
          </b-col>

          <b-col id="section-field-detail">
            <StationDetail
              class="map-detail-area"
              :autoUpdate="true"
            ></StationDetail>

            <div class="text-right">
              <div class="go-to-top-button" @click="go_to_map">
                <i class="fas fa-angle-up"></i> {{ $t("menu.go_to_top") }}
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal, Button } from "@/components";
import MapCSS from "./components/Map_CSS";
// import MapTaiwan from './components/Map_Taiwan';
import StationSummary from "./components/StationSummary";
import StationDetail from "./components/StationDetail";

export default {
  components: {
    Modal,
    [Button.name]: Button,
    MapCSS,
    // MapTaiwan,
    StationSummary,
    StationDetail
  },
  data() {
    return {
      loading: false,
      blossom_dates: {}
    };
  },
  created() {
    // 根據北~南排序
    this.$store.commit("data/reorder_stations");
  },
  mounted() {
    this.switch_Language(this.language);
    this.get_Data();
    this.init_location(this.location_id);
  },
  computed: {
    language() {
      return this.$route.query.lang;
    },

    location_id() {
      let loca_id =
        parseInt(this.$route.query.id) > 10
          ? 1
          : parseInt(this.$route.query.id);

      return loca_id;
    },

  },
  watch: {
    language(val, oldVal) {
      this.switch_Language(val);
    }
  },
  methods: {

    //NOTE - 將年份動態帶入描述文字中
    transformYear(description = '') {
      const year_tw = new Date().getFullYear() - 1911;
      const year_en = new Date().getFullYear();

      if (description.includes("{year_tw}")) {
        return description.replace("{year_tw}", year_tw).replace("{year_tw}", year_tw);
      }

      return description.replace("{year_en}", year_en).replace("{year_en}", year_en);
    },

    // 取得開花日期總覽
    get_Data() {
      this.loading = true;
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Blossom_Dates")
      };
      this.$http(options)
        .then(res => {
          // console.log( res.data )
          let _field_dates = {};
          if (res.data.fields != undefined) {
            res.data.fields.forEach(_item => {
              _item.run_time = this.$moment(_item.run_time).format(
                "YYYY-MM-DD HH:mm"
              );
              _item.flowering_date = this.$moment(_item.flowering_date).format(
                "YYYY-MM-DD"
              );
              _item.blooming_date = this.$moment(_item.blooming_date).format(
                "YYYY-MM-DD"
              );
              _field_dates[_item.field_id] = _item;
            });
          }

          this.blossom_dates = _field_dates;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    switch_Language(lang = undefined) {
      let _check_lang = "zh-Hant-TW";
      switch (lang) {
        case "en":
          _check_lang = lang;
          break;
        case "ja":
          _check_lang = lang;
          break;
        case "jp":
          _check_lang = "ja";
          break;

        default:
          _check_lang = "zh-Hant-TW";
          break;
      }

      this.$i18n.locale = _check_lang;
      this.$store.commit("user/set_Language", _check_lang);
    },

    go_to_map() {
      let html = document.getElementById("section-map");

      html.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    },

    init_location(station_code) {
      // this.go_detail();
      this.$store.commit("data/select_station", station_code);
    }
  }
};
</script>

<style lang="scss" scoped>
$flowering-color: #fe6357;
$blooming-color: #232175;

.content-center {
  h1,
  h3 {
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
  }
}

.more-detail-button {
  cursor: pointer;
  font-size: 1.8rem;
  opacity: 0.3;
  transform: scaleX(1.5);

  // i {
  //     margin-left: 10px;
  // }

  &:hover,
  &:focus,
  &:active {
    // transform: scale(1.2);
    opacity: 1;
  }
}

.go-to-top-button {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 5px;
  margin-right: 15px;
  color: $blooming-color;
  // color: #b89706;

  i {
    vertical-align: middle;
    font-size: 1.6rem;
    margin-bottom: 3px;
  }

  &:hover,
  &:focus,
  &:active {
    transform: scale(1.2);
    color: $flowering-color;
  }
}

.page-header-title {
  font-size: 2.2rem;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
}
.page-header-description {
  font-size: 1.2rem;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
}
.cover-info-box {
  padding: 30px 50px !important;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
  border-radius: 2px;
}
.platform-logo {
  width: 90%;
  max-width: 200px;
  margin-top: 80px;
  margin-left: -10px;
  margin-bottom: 15px;
}

.section {
  padding-bottom: 80px;
  .title {
    margin-bottom: 20px;
  }
  .map-detail-area {
    margin-top: 10px;
  }
}
</style>
